<div
  class="container"
  [ngClass]="[size, clickableForUpload ? 'editable' : '']"
>
  <ng-container *ngIf="logoUrl; else noLogo">
    <img
      class="image"
      [src]="logoUrl"
      [alt]="firstName + ' ' + lastName"
      (error)="logoUrl = null"
    />
    <div *ngIf="isLoading" class="logo-placeholder"></div>
  </ng-container>

  <ng-template #noLogo>
    <div
      class="placeholder"
      [ngStyle]="{ 'background-color': placeholderColor }"
    >
      <span *ngFor="let l of getInitials()">{{ l }}</span>
    </div>
  </ng-template>

  <div *ngIf="clickableForUpload" class="edit-overlay">
    <svg
      width="40%"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41L18.37 3.3a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.84z"
        fill="currentColor"
      />
    </svg>
  </div>
</div>
